module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_PT-ade90163bd493b6b6b9f3b800b688608.svg";